module.exports = __webpack_public_path__ + "images/apps/zhirenhr-337b09ad4cd07ccd2ec3b2fd9c8a8664.png";